import { createApp } from 'vue'
import App from './App.vue';
import router from '@/router/index.tsx'
import i18n from '@/i18n'
import lazyLoad from '@/directives/lazyLoad'

const app = createApp(App)

// 注册全局指令
app.directive('lazy', lazyLoad)

// 使用插件
app.use(router).use(i18n).mount('#app')
